import React from "react";
import Text from "./Controls/Text";
import Dropdown from "./Controls/DropDown";
import SearchWithLoader from "./Controls/SearchWithLoader";
import TextArea from "./Controls/TextArea";
import DynamicTokenInput from "./Controls/DynamicTokenInput";

interface IFormControlProps {
  control: string;
  name: string;
  label: string;
  placeholder: string;
  filteredList?: string[];
  disabled?: boolean;
  handleNameChange?: (event: any) => void;
  isLoading?: boolean;
  dropdownOptions?: string[];
  keywordsMap?: Record<string, string>;
  searchOption?: boolean;
  loader?: boolean;
  initialValues?: string;
  itemIndex?: number;
  required?: boolean;
}
const FormControl: React.FC<IFormControlProps> = ({
  control,
  name,
  label,
  placeholder,
  filteredList,
  disabled,
  isLoading,
  dropdownOptions = [],
  keywordsMap = {},
  searchOption = false,
  loader = false,
  initialValues = "",
  itemIndex = 0,
  required = false
}) => {
  switch (control) {
    case "text":
      return (
        <Text
          name={name}
          label={label}
          placeholder={placeholder}
          disabled={disabled}
          required={required}
        />
      );
    case "dropdown":
      return filteredList && filteredList.length > 0 ? (
        <Dropdown
          name={name}
          label={label}
          placeholder={placeholder}
          filteredList={filteredList}
          disabled={disabled}
        />
      ) : (
        <></>
      );
    case "searchwithloader":
      return (
        <SearchWithLoader
          name={name}
          label={label}
          placeholder={placeholder}
          disabled={disabled}
          isLoading={isLoading ?? false}
        />
      );
    case "textarea":
      return (
        <TextArea
          name={name}
          label={label}
          placeholder={placeholder}
          disabled={disabled}
        />
      );
    case "dynamictoken":
      return (
        <DynamicTokenInput
          name={name}
          label={label}
          placeholder={placeholder}
          dropdownOptions={dropdownOptions}
          keywordsMap={keywordsMap}
          searchOption={searchOption}
          loader={loader}
          initialValues={initialValues}
          itemIndex={itemIndex}
        />
      );

    default:
      return null;
  }
};

export { FormControl };
